
import { TrustAPI } from "@/shared/modules/trust-api";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import {Inject, Options, Vue} from "vue-property-decorator";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { LinkedPracticeView, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import { AppInsights } from "@/trust-admin-app/appInsights";
import AddEditLinkedPracticeModal from "./add-edit-linked-practice-modal/index.vue";

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    AddEditLinkedPracticeModal,
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticeLinkedPractices extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private linkedPracticesHeadings = [
    { text: 'Practice (Trading name)', value: 'practiceName', sortable: false },
    { text: 'Practice - branch ID', value: 'practiceBranchID', sortable: false },
    { text: 'Latest trust status', value: 'latestTrustStatus', sortable: false },
    { text: 'Date', value: 'Date', sortable: false },
    { text: 'Action', value: 'actions', sortable: false }
  ];

  private ai = new AppInsights;

  private loadingContent = false;
  private errorLoadingContent = false;
  private showLinkedPracticeModal = false;
  private selectedLinkedPractice = null as any;
  private transferMode = -1;
  private linkedPractices: LinkedPracticeView[] = [];


  created(): void {
    this.loadLinkedPractices();
  }

  mounted(): void {
    this.eventCtrl.on('reload-linked-practices', this.loadLinkedPractices);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-linked-practices', this.loadLinkedPractices);
  }

  private async loadLinkedPractices(): Promise<void> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;
      const res: any = await this.apiService.PracticeApi?.apiV2PracticeGetLinkedPracticesPracticeIdGet(this.selectedPractice.id);
      this.linkedPractices = res.data.data;
    } catch (error) {
      this.errorLoadingContent = true;
      this.eventCtrl.emit('show-snackbar', 'error', 'Error on loading linked practices - ' + error);
      this.ai.trackException('Error on loading linked practices: ' + error);
    } finally {
      this.loadingContent = false;
    }
  }

  private openAddEditLinkedPracticeModal(lp: LinkedPracticeView, mode: number): void {
    this.selectedLinkedPractice = lp;
    this.transferMode = mode;
    this.showLinkedPracticeModal = true;
  }

  private closeAddEditLinkedPracticeModal(): void {
    this.selectedLinkedPractice = null as any;
    this.transferMode = -1;
    this.showLinkedPracticeModal = false;
  }

  get practicesFrom(): LinkedPracticeView[] {
    return this.linkedPractices.filter(x => x.isFromPractice);
  }

  get practicesTo(): LinkedPracticeView[] {
    return this.linkedPractices.filter(x => !x.isFromPractice);
  }

  get eventCtrl(): EventEmitter {
   return store.getters.getEventController;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}

